import React from "react";
import { he } from "date-fns/locale";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Calendar } from "react-date-range";

const MobileDateRangePicker = () => {
  return (
    <form>
      <div style={{ marginRight: 20, display: "flex" }}>
        <div
          style={{
            display: "flex",
            border: `1px solid rgba(220,223,226,1)`,
            borderRadius: 10,
            lineHeight: 1,
            maxHeight: "2.7em",
            flexDirection: "column",
          }}>
          <Calendar date={new Date()} onChange={() => {}} locale={he} />
        </div>
      </div>
    </form>
  );
};
export default MobileDateRangePicker;
